<div class="main-footer " style="margin-left: 0%; margin-top: 0.5rem; padding: 0%; padding-top: 0.5rem;">
    <div class="row card-body">
        <div class="col">
   <p style="margin: 0%;"> Creato da:<strong> {{info.creato}} </strong> - {{ info.dal | date: 'dd/MM/yyyy [HH:mm:ss]'}}</p>
        </div>
        <div class="col">
    <p style="margin: 0%; text-align: right;">Ultima modifica da:<strong> {{info.modificato}} </strong> - {{ info.al | date: 'dd/MM/yyyy [HH:mm:ss]'}}</p>
        </div>
    </div>
</div>